import type React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Tabs } from '@nvision/ui';

import styles from './tabs-layout.module.css';

export interface TabItem {
  label: React.ReactNode;
  to: string;
}

export interface TabsLayoutProps {
  children: React.ReactNode;
  tabs: TabItem[];
}

const resolveSelectedKey = (pathname: string, tabs: TabItem[]): string => {
  const match = tabs
    .filter((tab) => pathname === tab.to || pathname.startsWith(`${tab.to}/`))
    .sort((a, b) => b.to.length - a.to.length)[0];

  return match?.to ?? tabs[0]?.to ?? '';
};

export const TabsLayout: React.FC<TabsLayoutProps> = ({ children, tabs }) => {
  const { pathname } = useLocation();
  const selectedKey = resolveSelectedKey(pathname, tabs);

  return (
    <Tabs className={styles.tabs} selectedKey={selectedKey}>
      <Tabs.List className={styles.tabList}>
        {tabs.map((tab) => (
          <Tabs.Tab className={styles.tab} id={tab.to} key={tab.to}>
            <Link to={tab.to} className={styles.tabLink}>
              {tab.label}
            </Link>
          </Tabs.Tab>
        ))}
      </Tabs.List>
      {tabs.map((tab) => (
        <Tabs.Panel className={styles.tabPanel} id={tab.to} key={tab.to}>
          {children}
        </Tabs.Panel>
      ))}
    </Tabs>
  );
};
